import { createGlobalState } from 'react-hooks-global-state'
import { UserResponseDto } from '@headbox-ui/auth-hook/dist/useGlobalAuth'
import { ActorRoles } from '../BusinessLogic'
export interface Session {
  role: ActorRoles
  user: UserResponseDto
}
export interface GlobalState {
  session: Session
  withoutNav: boolean
}

export const initialState = {
  session: {
    role: undefined,
    user: undefined
  },
  withoutNav: undefined
}

export const { useGlobalState } = createGlobalState<GlobalState>(initialState)
